import { render, staticRenderFns } from "./BountyCarousel.vue?vue&type=template&id=5b5d6a4a&scoped=true"
import script from "./BountyCarousel.vue?vue&type=script&lang=js"
export * from "./BountyCarousel.vue?vue&type=script&lang=js"
import style0 from "./BountyCarousel.vue?vue&type=style&index=0&id=5b5d6a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5d6a4a",
  null
  
)

export default component.exports